const BaseLineIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
            <g fill='none' stroke="currentColor">
                <path stroke-dasharray="1,1" d="M4 14.5h22"></path>
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 12.5l2-4 1 2 2-4 3 6"></path>
                <path stroke-linecap="round" d="M5.5 16.5l-1 2"></path>
                <path stroke-linecap="round" stroke-linejoin="round" d="M17.5 16.5l2 4 2-4m2-4l1-2-1 2z"></path>
            </g>
        </svg>


    )
}

export default BaseLineIcon;
